import React, { lazy, memo } from "react";
import { Box, Button, Typography } from "@material-ui/core";
import { useOrganizationConstants } from "Hooks/organization/useOrganizationConstants";
import { useFormContext } from "react-hook-form";
import useStyles from "../../../../styles";
import { TOTAL_STRENGTHS_TAG } from "src/constants";
import { orderBy } from "lodash";
const EditStrength = lazy(() => import("../../EditStrength"));

const AddStrengths = () => {
  const { watch, setValue, trigger, setError } = useFormContext();
  const { initialStrength } = useOrganizationConstants();
  const classes = useStyles();
  const { addStrength, listOfStrength, removedStrength } = watch(
    "configuration.strengths"
  );
  const addTags = async () => {
    let isValid = await trigger("configuration.strengths.addStrength");
    if (listOfStrength?.length >= TOTAL_STRENGTHS_TAG) {
      setError("configuration.strengths.addStrength.name", {
        type: "Custom",
        message: `Only ${TOTAL_STRENGTHS_TAG} strengths can be added.`,
      });
      isValid = false;
      return;
    } else if (!addStrength?.name?.trimLeft()) {
      setError("configuration.strengths.addStrength.name", {
        type: "Custom",
        message: `Please enter valid title`,
      });
      isValid = false;
    }
    const checkDuplicateName = listOfStrength?.find(
      (res) => res.name.toLowerCase() === addStrength?.name?.toLowerCase()
    );
    if (checkDuplicateName?.name) {
      setError("configuration.strengths.addStrength.name", {
        type: "Custom",
        message: "Strength already present",
      });
      isValid = false;
      return;
    }
    if (isValid)
      setValue("configuration.strengths", {
        listOfStrength: orderBy([...listOfStrength, addStrength], "name"),
        addStrength: initialStrength,
        removedStrength,
      });
  };
  return (
    <Box mb={3}>
      <Typography variant="subtitle2" className="font-semibold font-14">
        Add strength tag
      </Typography>
      <Box className="border rounded position-relative" p={2} mt={0.5}>
        <Button
          color="primary"
          data-testid="btn"
          className={classes.addTag}
          onClick={() => addTags()}
          disabled={!addStrength?.name}
        >
          Add tag
        </Button>
        <EditStrength
          name={"configuration.strengths.addStrength"}
          data={addStrength}
          showLabel={true}
          addTags={() => addTags()}
        />
      </Box>
    </Box>
  );
};

export default memo(AddStrengths);
